module.exports = __webpack_public_path__ + "img/spiral-clockwise-middle.5243fba1.png";